import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import { arrayOf, number, string } from "prop-types";

const DDJJItem = ({ formId, vKey, row }) => (
    <GridTable.Data columnStart={2} columnWidth={10} rowStart={row} key={vKey}>
        <I18n id={`${formId}.${vKey}`} componentProps={{ className: "ddjj-item" }} />
    </GridTable.Data>
);

DDJJItem.propTypes = {
    formId: arrayOf(string).isRequired,
    vKey: string.isRequired,
    row: number.isRequired,
};

export default DDJJItem;
